class PMStickyMobileCart extends HTMLElement {
connectedCallback() {

  this.sectionId = this.dataset.sectionId;

  this.productId = this.dataset.productId || '';

  this.productHandle = this.dataset.productHandle || '';

  this.isPoster = this.isCustomPoster();

  /*
   * Wszystkie normalne produkty korzystają teraz z natywnego
   * Cloudlift data-live-price-quantity.
   *
   * Custom Poster pozostaje całkowicie niezależny.
   */

  this.priceNode = this.isPoster
    ? this.querySelector('[data-pm-sticky-poster-price]')
    : this.querySelector('[data-pm-sticky-price]');

  this.cloudliftManagedPrice =
    !this.isPoster &&
    !!this.priceNode?.hasAttribute('data-live-price-quantity');

    this.button = this.querySelector('[data-pm-sticky-submit]');

    this.mainSubmit = document.getElementById(
      `ProductSubmitButton-${this.sectionId}`
    );

    this.mainPrice = document.getElementById(
      `price-${this.sectionId}`
    );

    /* =====================================================
       CUSTOM POSTER STATE
    ===================================================== */

    this.posterQuantity = 1;
    this.posterQuantitySyncing = false;
    this.posterQuantityUserIntent = false;
    this.posterExpectedQuantity = null;
    this.posterExpectedQuantityUntil = 0;
    this.posterSize = 'A4';

    this.posterUploadActive = false;

    /* =====================================================
       VOLUME DISCOUNTS — DOUBLE TAP MOBILE
    ===================================================== */

    this.posterPendingDiscountQuantity = null;
    this.posterPendingDiscountTime = 0;

    /* =====================================================
       VOLUME DISCOUNTS — SCROLL DETECTION
    ===================================================== */

    this.posterDiscountPointerActive = false;
    this.posterDiscountPointerMoved = false;
    this.posterDiscountPointerX = 0;
    this.posterDiscountPointerY = 0;

    /* =====================================================
       BIND
    ===================================================== */

    this.onSubmit = this.handleSubmit.bind(this);
    this.onVariantChange = this.handleVariantChange.bind(this);
    this.onLpoPrice = this.handleLpoPrice.bind(this);

    this.onPosterChange = this.handlePosterChange.bind(this);
    this.onPosterPointerDown = this.handlePosterPointerDown.bind(this);
    this.onPosterPointerMove = this.handlePosterPointerMove.bind(this);
    this.onPosterDiscountClick = this.handlePosterDiscountClick.bind(this);
    this.onPosterKeyDown = this.handlePosterKeyDown.bind(this);
    this.onPosterMutation = this.handlePosterMutation.bind(this);

    this.onMainButtonMutation = this.syncButtonState.bind(this);
    this.onPriceMutation = () => this.syncPriceFromMain();

    /* =====================================================
       GENERAL
    ===================================================== */

    this.button?.addEventListener(
      'click',
      this.onSubmit
    );

    document.addEventListener(
      'lpo:price',
      this.onLpoPrice
    );

    document.body.classList.add(
      'pm-sticky-cart-visible'
    );

    /* =====================================================
       CUSTOM POSTER
    ===================================================== */

    if (this.isPoster) {
      this.posterSize =
        this.readSelectedPosterSize();

      this.posterQuantity =
        this.readPosterQuantity();

      document.addEventListener(
        'input',
        this.onPosterChange,
        true
      );

      document.addEventListener(
        'change',
        this.onPosterChange,
        true
      );

      document.addEventListener(
        'pointerdown',
        this.onPosterPointerDown,
        true
      );

      document.addEventListener(
        'pointermove',
        this.onPosterPointerMove,
        true
      );

      document.addEventListener(
        'click',
        this.onPosterDiscountClick,
        true
      );

      document.addEventListener(
        'keydown',
        this.onPosterKeyDown,
        true
      );

      window.addEventListener(
        'option:changed',
        this.onPosterChange
      );

      document.addEventListener(
        'options:rendered',
        this.onPosterChange
      );

      this.observeCustomPoster();
      this.observePosterUpload();

      this.renderCustomPosterSticky();
    }

    /* =====================================================
       DAWN VARIANT CHANGE
    ===================================================== */

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      this.unsubscribeVariantChange = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.onVariantChange
      );
    }

    /* =====================================================
       BUTTON OBSERVER
    ===================================================== */

    if (this.mainSubmit) {
      this.buttonObserver =
        new MutationObserver(
          this.onMainButtonMutation
        );

      this.buttonObserver.observe(
        this.mainSubmit,
        {
          attributes: true,
          attributeFilter: [
            'disabled',
            'aria-disabled'
          ],
          childList: true,
          subtree: true
        }
      );
    }

    /* =====================================================

   NORMAL PRICE OBSERVER

   WAŻNE:
   Jeśli sticky price jest zarządzany przez Cloudlift
   data-live-price-quantity, Dawn NIE może go nadpisywać.

===================================================== */

if (
  this.mainPrice &&
  !this.isPoster &&
  !this.cloudliftManagedPrice
) {

  this.priceObserver =
    new MutationObserver(
      this.onPriceMutation
    );

  this.priceObserver.observe(
    this.mainPrice,
    {
      childList: true,
      subtree: true,
      characterData: true
    }
  );
}

    this.syncButtonState();

    if (this.isPoster) {
      return;
    }

    if (
      this.applyDocumentPrintingEmptyPrice()
    ) {
      return;
    }

    this.syncPriceFromMain();
  }


  /* =========================================================
     DISCONNECT
  ========================================================= */

  disconnectedCallback() {
    this.button?.removeEventListener(
      'click',
      this.onSubmit
    );

    document.removeEventListener(
      'lpo:price',
      this.onLpoPrice
    );

    document.removeEventListener(
      'input',
      this.onPosterChange,
      true
    );

    document.removeEventListener(
      'change',
      this.onPosterChange,
      true
    );

    document.removeEventListener(
      'pointerdown',
      this.onPosterPointerDown,
      true
    );

    document.removeEventListener(
      'pointermove',
      this.onPosterPointerMove,
      true
    );

    document.removeEventListener(
      'click',
      this.onPosterDiscountClick,
      true
    );

    document.removeEventListener(
      'keydown',
      this.onPosterKeyDown,
      true
    );

    window.removeEventListener(
      'option:changed',
      this.onPosterChange
    );

    document.removeEventListener(
      'options:rendered',
      this.onPosterChange
    );

    this.unsubscribeVariantChange?.();

    this.buttonObserver?.disconnect();
    this.priceObserver?.disconnect();
    this.posterObserver?.disconnect();
    this.posterUploadObserver?.disconnect();

    clearTimeout(this.posterRenderTimer);
    clearTimeout(this.posterDiscountTimer);
    clearTimeout(this.posterUserIntentTimer);
    clearTimeout(this.posterRestoreTimer);
    clearTimeout(this.posterUploadTimer);

    document.body.classList.remove(
      'pm-sticky-cart-visible'
    );
  }


  /* =========================================================
     PRODUCTS
  ========================================================= */

  isDocumentPrinting() {
    return /\/products\/document-printing(?:\/|$)/i.test(
      window.location.pathname
    );
  }


  isCustomPoster() {
    return /\/products\/custom-poster(?:\/|$)/i.test(
      window.location.pathname
    );
  }


  /* =========================================================
     DOCUMENT PRINTING
  ========================================================= */

  documentHasUpload() {
    if (!this.isDocumentPrinting()) {
      return false;
    }

    const upload = document.querySelector(
      '[data-option="Upload Document"]'
    );

    if (!upload) {
      return false;
    }

    if (
      upload.querySelector('.filepond--item')
    ) {
      return true;
    }

    return Array.from(
      upload.querySelectorAll(
        'input[type="hidden"]'
      )
    ).some((input) => {
      return /^https?:\/\//i.test(
        String(input.value || '')
      );
    });
  }


  findStickyLabel() {
    return Array.from(
      this.querySelectorAll('*')
    ).find((element) => {
      if (
        element === this.priceNode ||
        element.children.length
      ) {
        return false;
      }

      const text = String(
        element.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();

      return (
        text === 'TOTAL' ||
        text === 'FROM' ||
        text === 'ORDER TOTAL'
      );
    }) || null;
  }


  setStickyLabel(value) {
    const label =
      this.findStickyLabel();

    if (!label) {
      return;
    }

    label.textContent = value;
  }


  applyDocumentPrintingEmptyPrice() {
    if (
      this.isDocumentPrinting() &&
      !this.documentHasUpload()
    ) {
      this.setStickyLabel('FROM');
      this.setPrice('€0,40');

      return true;
    }

    return false;
  }


  /* =========================================================
     CUSTOM POSTER — UPLOAD ROOT
  ========================================================= */

  getPosterUploadRoot() {
    return (
      document.querySelector(
        '.cl-po--option[data-option="file_upload"]'
      ) ||
      document.querySelector(
        '[data-option="file_upload"]'
      ) ||
      document.querySelector(
        '.cl-po--option[data-option*="upload" i]'
      )
    );
  }


  /* =========================================================
     CUSTOM POSTER — REAL UPLOAD CHECK
  ========================================================= */

  posterHasRealUpload() {
    if (!this.isPoster) {
      return false;
    }

    const root =
      this.getPosterUploadRoot();

    if (!root) {
      return false;
    }

    const pondItems = Array.from(
      root.querySelectorAll(
        '.filepond--item'
      )
    );

    if (
      pondItems.some((item) => {
        return (
          item.querySelector(
            '.filepond--file'
          ) ||
          item.querySelector(
            '[data-filepond-item-state]'
          ) ||
          item.getAttribute(
            'data-filepond-item-state'
          )
        );
      })
    ) {
      return true;
    }

    const fileInputs = Array.from(
      root.querySelectorAll(
        'input[type="file"]'
      )
    );

    if (
      fileInputs.some(
        (input) =>
          input.files &&
          input.files.length > 0
      )
    ) {
      return true;
    }

    const uploadedLinks =
      Array.from(
        root.querySelectorAll(
          '.filepond--file-info-main, ' +
          '.filepond--file-info-sub, ' +
          '.cl-upload--file, ' +
          '.cl-upload--preview'
        )
      );

    if (
      uploadedLinks.some((element) => {
        const text = String(
          element.textContent || ''
        ).trim();

        return text.length > 0;
      })
    ) {
      return true;
    }

    return false;
  }


  /* =========================================================
     CUSTOM POSTER — OBSERVE UPLOAD
  ========================================================= */

  observePosterUpload() {
    if (!this.isPoster) {
      return;
    }

    this.posterUploadObserver?.disconnect();

    const root =
      this.getPosterUploadRoot();

    if (!root) {
      clearTimeout(
        this.posterUploadTimer
      );

      this.posterUploadTimer =
        setTimeout(
          () => {
            this.observePosterUpload();
          },
          300
        );

      return;
    }

    this.posterUploadObserver =
      new MutationObserver(
        () => {
          const hasUpload =
            this.posterHasRealUpload();

          if (
            hasUpload !==
            this.posterUploadActive
          ) {
            this.posterUploadActive =
              hasUpload;

            this.renderCustomPosterSticky();
          }
        }
      );

    this.posterUploadObserver.observe(
      root,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'data-filepond-item-state'
        ]
      }
    );

    requestAnimationFrame(() => {
      this.posterUploadActive =
        this.posterHasRealUpload();

      this.renderCustomPosterSticky();
    });
  }


  /* =========================================================
     CUSTOM POSTER — SIZE
  ========================================================= */

  readSelectedPosterSize() {
    const option =
      document.querySelector(
        '.cl-po--option[data-option="poster_size"]'
      );

    if (!option) {
      return this.posterSize || 'A4';
    }

    const checked =
      option.querySelector(
        'input[type="radio"]:checked'
      );

    const value = String(
      checked?.value || ''
    )
      .trim()
      .toUpperCase();

    if (
      [
        'A4',
        'A3',
        'A2',
        'A1',
        'A0'
      ].includes(value)
    ) {
      return value;
    }

    return this.posterSize || 'A4';
  }


  getSelectedPosterSize() {
    return this.posterSize || 'A4';
  }


  /* =========================================================
     CUSTOM POSTER — QUANTITY INPUT
  ========================================================= */

  getPosterQuantityInput() {
    const direct =
      document.querySelector(
        '.cl-po--options > .product-form__quantity input[name="quantity"]'
      ) ||
      document.querySelector(
        '.cl-po--options > .product-form__quantity .quantity__input'
      ) ||
      document.querySelector(
        '.cl-po--options > .product-form__quantity input[type="number"]'
      );

    if (direct) {
      return direct;
    }

    const forms = Array.from(
      document.querySelectorAll(
        '[id^="Quantity-Form-"]'
      )
    );

    for (const form of forms) {
      if (this.contains(form)) {
        continue;
      }

      const input =
        form.querySelector(
          'input[name="quantity"]'
        ) ||
        form.querySelector(
          '.quantity__input'
        ) ||
        form.querySelector(
          'input[type="number"]'
        );

      if (input) {
        return input;
      }
    }

    return null;
  }


  readPosterQuantity() {
    const input =
      this.getPosterQuantityInput();

    if (!input) {
      return 1;
    }

    const value = parseInt(
      input.value || '1',
      10
    );

    if (
      !Number.isFinite(value) ||
      value < 1
    ) {
      return 1;
    }

    return value;
  }


  getCanonicalPosterQuantityInput() {
    return this.getPosterQuantityInput();
  }


  isCanonicalPosterQuantityInput(target) {
    if (!target) {
      return false;
    }

    return (
      target ===
      this.getCanonicalPosterQuantityInput()
    );
  }


  getPosterQuantity() {
    if (
      Number.isFinite(
        this.posterQuantity
      ) &&
      this.posterQuantity >= 1
    ) {
      return this.posterQuantity;
    }

    return 1;
  }


  /* =========================================================
     CUSTOM POSTER — QUANTITY TARGET
  ========================================================= */

  isPosterQuantityTarget(target) {
    if (
      !target ||
      !target.closest
    ) {
      return false;
    }

    const quantityForm =
      target.closest(
        '.product-form__quantity'
      );

    if (!quantityForm) {
      return false;
    }

    if (
      this.contains(quantityForm)
    ) {
      return false;
    }

    return true;
  }


  markPosterQuantityUserIntent() {
    this.posterQuantityUserIntent =
      true;

    clearTimeout(
      this.posterUserIntentTimer
    );

    this.posterUserIntentTimer =
      setTimeout(
        () => {
          this.posterQuantityUserIntent =
            false;

          this.posterExpectedQuantity =
            null;

          this.posterExpectedQuantityUntil =
            0;
        },
        400
      );
  }


  clearPosterQuantityUserIntent() {
    this.posterQuantityUserIntent =
      false;

    this.posterExpectedQuantity =
      null;

    this.posterExpectedQuantityUntil =
      0;

    clearTimeout(
      this.posterUserIntentTimer
    );
  }


  resetPosterDiscountTap() {
    this.posterPendingDiscountQuantity =
      null;

    this.posterPendingDiscountTime =
      0;
  }


  handlePosterKeyDown(event) {
    if (!this.isPoster) {
      return;
    }

    if (
      this.isPosterQuantityTarget(
        event.target
      )
    ) {
      this.resetPosterDiscountTap();
      this.markPosterQuantityUserIntent();
    }
  }


  /* =========================================================
     CUSTOM POSTER — SET QUANTITY
  ========================================================= */

  setPosterQuantityInputValue(
    input,
    quantity,
    dispatchEvents = true
  ) {
    if (!input) {
      return;
    }

    const descriptor =
      Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        'value'
      );

    if (
      descriptor &&
      descriptor.set
    ) {
      descriptor.set.call(
        input,
        String(quantity)
      );
    } else {
      input.value =
        String(quantity);
    }

    if (!dispatchEvents) {
      return;
    }

    input.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );

    input.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );
  }


  applyPosterQuantity(
    quantity = this.posterQuantity
  ) {
    if (!this.isPoster) {
      return;
    }

    if (
      !Number.isFinite(quantity) ||
      quantity < 1
    ) {
      return;
    }

    const input =
      this.getPosterQuantityInput();

    if (!input) {
      return;
    }

    const current = parseInt(
      input.value || '1',
      10
    );

    if (current === quantity) {
      return;
    }

    this.posterQuantitySyncing =
      true;

    this.setPosterQuantityInputValue(
      input,
      quantity,
      true
    );

    requestAnimationFrame(() => {
      this.posterQuantitySyncing =
        false;

      this.renderCustomPosterSticky();
    });
  }


  /* =========================================================
     CUSTOM POSTER — DISCOUNT HELPERS
  ========================================================= */

  getPosterDiscountOption(target) {
    if (
      !target ||
      !target.closest
    ) {
      return null;
    }

    const option =
      target.closest(
        '.cl-po--option[data-option]'
      );

    if (!option) {
      return null;
    }

    const name = String(
      option.dataset.option || ''
    );

    if (
      !/^Quantity(?:_A[0-4])?$/i.test(
        name
      )
    ) {
      return null;
    }

    return option;
  }


  getPosterDiscountQuantity(target) {
    const option =
      this.getPosterDiscountOption(
        target
      );

    if (!option) {
      return null;
    }

    let current = target;

    while (current) {
      const text = String(
        current.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim();

      const matches = Array.from(
        text.matchAll(
          /\bBUY\s*(5|10|25|50|100)\s*\+/gi
        )
      );

      const values = [
        ...new Set(
          matches.map(
            (match) =>
              parseInt(
                match[1],
                10
              )
          )
        )
      ];

      if (values.length === 1) {
        return values[0];
      }

      if (current === option) {
        break;
      }

      current =
        current.parentElement;
    }

    return null;
  }


  clearPosterDiscountRadios() {
    document
      .querySelectorAll(
        '.cl-po--option[data-option^="Quantity"] input[type="radio"]'
      )
      .forEach((radio) => {
        radio.checked = false;
      });
  }


  /* =========================================================
     CUSTOM POSTER — POINTER DOWN
  ========================================================= */

  handlePosterPointerDown(event) {
    if (!this.isPoster) {
      return;
    }

    /* =====================================================
       SHOW ALL / SHOW LESS

       Nie traktujemy tego przycisku
       jako Volume Discount.
    ===================================================== */

    if (
      event.target?.closest?.(
        '.pm-volume-toggle'
      )
    ) {
      this.posterDiscountPointerActive =
        false;

      this.posterDiscountPointerMoved =
        false;

      return;
    }

    /* =====================================================
       VOLUME DISCOUNT ROW
    ===================================================== */

    const discountOption =
      this.getPosterDiscountOption(
        event.target
      );

    const discountQuantity =
      this.getPosterDiscountQuantity(
        event.target
      );

    if (
      discountOption &&
      Number.isFinite(
        discountQuantity
      )
    ) {
      this.posterDiscountPointerActive =
        true;

      this.posterDiscountPointerMoved =
        false;

      this.posterDiscountPointerX =
        event.clientX;

      this.posterDiscountPointerY =
        event.clientY;

      return;
    }

    /* =====================================================
       SIZE
    ===================================================== */

    const sizeOption =
      event.target?.closest?.(
        '.cl-po--option[data-option="poster_size"]'
      );

    if (sizeOption) {
      this.resetPosterDiscountTap();

      this.clearPosterQuantityUserIntent();

      return;
    }

    /* =====================================================
       NUMBER OF POSTERS + / -
    ===================================================== */

    if (
      !this.isPosterQuantityTarget(
        event.target
      )
    ) {
      return;
    }

    this.resetPosterDiscountTap();

    this.markPosterQuantityUserIntent();

    const button =
      event.target.closest(
        'button[name="plus"], button[name="minus"]'
      );

    if (!button) {
      this.posterExpectedQuantity =
        null;

      this.posterExpectedQuantityUntil =
        0;

      return;
    }

    const currentQuantity =
      this.getPosterQuantity();

    let nextQuantity =
      currentQuantity;

    if (
      button.name === 'plus'
    ) {
      nextQuantity =
        currentQuantity + 1;
    }

    if (
      button.name === 'minus'
    ) {
      nextQuantity =
        Math.max(
          1,
          currentQuantity - 1
        );
    }

    this.posterExpectedQuantity =
      nextQuantity;

    this.posterExpectedQuantityUntil =
      Date.now() + 350;

    this.posterQuantity =
      nextQuantity;

    this.renderCustomPosterSticky();
  }


  /* =========================================================
     CUSTOM POSTER — POINTER MOVE / SCROLL
  ========================================================= */

  handlePosterPointerMove(event) {
    if (
      !this.isPoster ||
      !this.posterDiscountPointerActive
    ) {
      return;
    }

    const dx =
      Math.abs(
        event.clientX -
        this.posterDiscountPointerX
      );

    const dy =
      Math.abs(
        event.clientY -
        this.posterDiscountPointerY
      );

    if (
      dx > 8 ||
      dy > 8
    ) {
      this.posterDiscountPointerMoved =
        true;

      this.resetPosterDiscountTap();

      this.clearPosterDiscountRadios();
    }
  }


  /* =========================================================
     CUSTOM POSTER — DISCOUNT CLICK

     DESKTOP:
     1 CLICK

     MOBILE / TOUCH:
     2 TAPS
  ========================================================= */

  handlePosterDiscountClick(event) {
    if (!this.isPoster) {
      return;
    }

    /* =====================================================
       SHOW ALL / SHOW LESS

       MUSI działać normalnie.
    ===================================================== */

    if (
      event.target?.closest?.(
        '.pm-volume-toggle'
      )
    ) {
      this.posterDiscountPointerActive =
        false;

      this.posterDiscountPointerMoved =
        false;

      return;
    }

    /* =====================================================
       MUSI BYĆ KONKRETNY BUY X+
    ===================================================== */

    const discountQuantity =
      this.getPosterDiscountQuantity(
        event.target
      );

    if (
      !Number.isFinite(
        discountQuantity
      ) ||
      ![
        5,
        10,
        25,
        50,
        100
      ].includes(
        discountQuantity
      )
    ) {
      return;
    }

    /*
     * Dopiero tutaj blokujemy
     * natywne label/radio Cloudlift.
     */
    event.preventDefault();
    event.stopPropagation();

    this.clearPosterDiscountRadios();

    /* =====================================================
       SCROLL = NIE TAP
    ===================================================== */

    if (
      this.posterDiscountPointerMoved
    ) {
      this.posterDiscountPointerActive =
        false;

      this.posterDiscountPointerMoved =
        false;

      this.resetPosterDiscountTap();

      return;
    }

    this.posterDiscountPointerActive =
      false;

    /* =====================================================
       DESKTOP = SINGLE CLICK
    ===================================================== */

    const isDesktopPointer =
      window.matchMedia(
        '(hover: hover) and (pointer: fine)'
      ).matches;

    /*
     * event.detail === 0
     * pozwala również na obsługę klawiatury.
     */
    const singleClickMode =
      isDesktopPointer ||
      event.detail === 0;

    if (singleClickMode) {
      this.resetPosterDiscountTap();

      this.clearPosterQuantityUserIntent();

      this.posterQuantity =
        discountQuantity;

      this.clearPosterDiscountRadios();

      this.renderCustomPosterSticky();

      clearTimeout(
        this.posterDiscountTimer
      );

      this.posterDiscountTimer =
        setTimeout(
          () => {
            this.applyPosterQuantity(
              discountQuantity
            );

            requestAnimationFrame(
              () => {
                this.clearPosterDiscountRadios();

                this.renderCustomPosterSticky();
              }
            );
          },
          50
        );

      return;
    }

    /* =====================================================
       MOBILE = DOUBLE TAP
    ===================================================== */

    const now =
      Date.now();

    const sameQuantity =
      this.posterPendingDiscountQuantity ===
      discountQuantity;

    const withinDoubleTapWindow =
      now -
      (
        this.posterPendingDiscountTime ||
        0
      ) <= 1200;

    /* =====================================================
       FIRST TAP
    ===================================================== */

    if (
      !sameQuantity ||
      !withinDoubleTapWindow
    ) {
      this.posterPendingDiscountQuantity =
        discountQuantity;

      this.posterPendingDiscountTime =
        now;

      return;
    }

    /* =====================================================
       SECOND TAP
    ===================================================== */

    this.resetPosterDiscountTap();

    this.clearPosterQuantityUserIntent();

    this.posterQuantity =
      discountQuantity;

    this.clearPosterDiscountRadios();

    this.renderCustomPosterSticky();

    clearTimeout(
      this.posterDiscountTimer
    );

    this.posterDiscountTimer =
      setTimeout(
        () => {
          this.applyPosterQuantity(
            discountQuantity
          );

          requestAnimationFrame(
            () => {
              this.clearPosterDiscountRadios();

              this.renderCustomPosterSticky();
            }
          );
        },
        50
      );
  }


  /* =========================================================
     CUSTOM POSTER — PRICE TABLE
  ========================================================= */

  getPosterUnitPrice(
    size,
    quantity
  ) {
    const tiers = {
      A4: [
        [100, 1.25],
        [50, 1.75],
        [25, 3.00],
        [10, 3.50],
        [5, 4.00],
        [1, 5.00]
      ],

      A3: [
        [100, 2.40],
        [50, 3.20],
        [25, 4.00],
        [10, 5.20],
        [5, 6.00],
        [1, 8.00]
      ],

      A2: [
        [100, 4.50],
        [50, 6.00],
        [25, 7.50],
        [10, 9.75],
        [5, 11.25],
        [1, 15.00]
      ],

      A1: [
        [100, 7.50],
        [50, 10.00],
        [25, 12.50],
        [10, 16.25],
        [5, 18.75],
        [1, 25.00]
      ],

      A0: [
        [100, 13.50],
        [50, 18.00],
        [25, 22.50],
        [10, 29.25],
        [5, 33.75],
        [1, 45.00]
      ]
    };

    const sizeTiers =
      tiers[size] ||
      tiers.A4;

    for (
      const tier of sizeTiers
    ) {
      if (
        quantity >= tier[0]
      ) {
        return tier[1];
      }
    }

    return sizeTiers[
      sizeTiers.length - 1
    ][1];
  }


  getPosterFromPrice(size) {
    const prices = {
      A4: '€1,25',
      A3: '€2,40',
      A2: '€4,50',
      A1: '€7,50',
      A0: '€13,50'
    };

    return (
      prices[size] ||
      prices.A4
    );
  }


  formatPosterMoney(value) {
    const number =
      Number(value);

    if (
      !Number.isFinite(number)
    ) {
      return '';
    }

    return (
      '€' +
      number
        .toFixed(2)
        .replace('.', ',')
    );
  }


  /* =========================================================
     CUSTOM POSTER — RENDER
  ========================================================= */

  renderCustomPosterSticky() {
    if (
      !this.isPoster ||
      !this.priceNode
    ) {
      return;
    }

    const size =
      this.getSelectedPosterSize();

    const quantity =
      this.getPosterQuantity();

    if (
      quantity === 1 &&
      !this.posterUploadActive
    ) {
      this.setStickyLabel('FROM');

      this.priceNode.textContent =
        this.getPosterFromPrice(
          size
        );

      return;
    }

    const unitPrice =
      this.getPosterUnitPrice(
        size,
        quantity
      );

    const total =
      unitPrice * quantity;

    this.setStickyLabel('TOTAL');

    this.priceNode.textContent =
      this.formatPosterMoney(
        total
      );
  }


  /* =========================================================
     CUSTOM POSTER — CHANGE
  ========================================================= */

  handlePosterChange(event) {
    if (!this.isPoster) {
      return;
    }

    const target =
      event?.target;

    /* =====================================================
       QUANTITY
    ===================================================== */

    if (
      target &&
      this.isCanonicalPosterQuantityInput(
        target
      )
    ) {
      if (
        this.posterQuantitySyncing
      ) {
        return;
      }

      const quantity =
        parseInt(
          target.value || '1',
          10
        );

      if (
        !Number.isFinite(
          quantity
        ) ||
        quantity < 1
      ) {
        return;
      }

      if (
        this.posterExpectedQuantity !== null &&
        Date.now() <=
          this.posterExpectedQuantityUntil
      ) {
        if (
          quantity !==
          this.posterExpectedQuantity
        ) {
          return;
        }

        this.posterQuantity =
          this.posterExpectedQuantity;

        this.posterExpectedQuantity =
          null;

        this.posterExpectedQuantityUntil =
          0;

        this.renderCustomPosterSticky();

        return;
      }

      if (
        !event.isTrusted &&
        !this.posterQuantityUserIntent
      ) {
        return;
      }

      if (
        !event.isTrusted &&
        this.posterQuantityUserIntent &&
        quantity === 1 &&
        this.posterQuantity > 1
      ) {
        return;
      }

      this.posterQuantity =
        quantity;

      this.resetPosterDiscountTap();

      this.renderCustomPosterSticky();

      return;
    }

    /* =====================================================
       SIZE
    ===================================================== */

    if (
      target?.matches?.(
        '.cl-po--option[data-option="poster_size"] input[type="radio"]'
      )
    ) {
      const size = String(
        target.value || ''
      )
        .trim()
        .toUpperCase();

      if (
        ![
          'A4',
          'A3',
          'A2',
          'A1',
          'A0'
        ].includes(
          size
        )
      ) {
        return;
      }

      this.resetPosterDiscountTap();

      this.clearPosterQuantityUserIntent();

      const savedQuantity =
        this.posterQuantity;

      this.posterSize =
        size;

      this.posterQuantity =
        savedQuantity;

      this.renderCustomPosterSticky();

      clearTimeout(
        this.posterRestoreTimer
      );

      this.posterRestoreTimer =
        setTimeout(
          () => {
            this.posterQuantity =
              savedQuantity;

            this.posterSize =
              size;

            const input =
              this.getCanonicalPosterQuantityInput();

            if (input) {
              const current =
                parseInt(
                  input.value || '1',
                  10
                );

              if (
                current !==
                savedQuantity
              ) {
                this.posterQuantitySyncing =
                  true;

                this.setPosterQuantityInputValue(
                  input,
                  savedQuantity,
                  true
                );

                requestAnimationFrame(
                  () => {
                    this.posterQuantitySyncing =
                      false;
                  }
                );
              }
            }

            this.renderCustomPosterSticky();
          },
          150
        );

      return;
    }

    requestAnimationFrame(
      () => {
        this.renderCustomPosterSticky();
      }
    );
  }


  /* =========================================================
     CUSTOM POSTER — LPO OBSERVER
  ========================================================= */

  observeCustomPoster() {
    if (!this.isPoster) {
      return;
    }

    this.posterObserver?.disconnect();

    const root =
      document.querySelector(
        '.cl-po--options'
      );

    if (!root) {
      return;
    }

    this.posterObserver =
      new MutationObserver(
        this.onPosterMutation
      );

    this.posterObserver.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );
  }


  handlePosterMutation() {
    if (!this.isPoster) {
      return;
    }

    clearTimeout(
      this.posterRenderTimer
    );

    this.posterRenderTimer =
      setTimeout(
        () => {
          const uploadRoot =
            this.getPosterUploadRoot();

          if (
            uploadRoot &&
            !this.posterUploadObserver
          ) {
            this.observePosterUpload();
          }

          this.renderCustomPosterSticky();
        },
        80
      );
  }


  /* =========================================================
     ADD TO CART
  ========================================================= */

  handleSubmit() {
    this.mainSubmit =
      document.getElementById(
        `ProductSubmitButton-${this.sectionId}`
      ) ||
      this.mainSubmit;

    if (
      !this.mainSubmit ||
      this.mainSubmit.disabled ||
      this.mainSubmit.getAttribute(
        'aria-disabled'
      ) === 'true'
    ) {
      return;
    }

    this.mainSubmit.click();
  }


  /* =========================================================
     VARIANT CHANGE
  ========================================================= */

  handleVariantChange(event) {
    if (
      event?.data?.sectionId !==
      this.sectionId
    ) {
      return;
    }

    this.mainSubmit =
      document.getElementById(
        `ProductSubmitButton-${this.sectionId}`
      ) ||
      this.mainSubmit;

    this.mainPrice =
      document.getElementById(
        `price-${this.sectionId}`
      ) ||
      this.mainPrice;

    this.syncButtonState();

    if (this.isPoster) {
      requestAnimationFrame(
        () => {
          this.renderCustomPosterSticky();
        }
      );

      return;
    }

    requestAnimationFrame(
      () => {
        if (
          this.applyDocumentPrintingEmptyPrice()
        ) {
          return;
        }

        this.syncPriceFromMain(
          event?.data?.html
        );
      }
    );
  }


  handleLpoPrice(event) {

  /*
   * CUSTOM POSTER
   *
   * Poster ma własny kalkulator ceny.
   * Nigdy nie pobieramy jego sticky price z Cloudlift.
   */

  if (this.isPoster) {

    this.renderCustomPosterSticky();

    return;
  }


  /*
   * DOCUMENT PRINTING
   *
   * Bez uploadu zachowujemy specjalny stan:
   *
   * FROM €0,40
   */

  if (
    this.applyDocumentPrintingEmptyPrice()
  ) {

    return;
  }


  /*
   * NORMAL CLOUDLIFT PRODUCTS
   *
   * Niczego tutaj NIE ustawiamy.
   *
   * Element:
   *
   * data-live-price-quantity="{{ product.id }}"
   *
   * jest aktualizowany bezpośrednio przez Cloudlift.
   *
   * Dzięki temu nie tworzymy drugiego źródła ceny.
   */

  if (this.cloudliftManagedPrice) {

    return;
  }


  /*
   * FALLBACK
   *
   * Tylko dla elementu, który nie jest zarządzany
   * przez data-live-price-quantity.
   */

  const price =
    event?.detail?.price;


  if (
    typeof price === 'string' &&
    price.trim()
  ) {

    this.setPrice(
      price.trim()
    );

    return;
  }


  if (
    typeof price === 'number' &&
    Number.isFinite(price)
  ) {

    this.setPrice(
      this.formatNumberPrice(
        price
      )
    );
  }
}


  /* =========================================================
     NORMAL PRICE FORMAT
  ========================================================= */

  formatNumberPrice(price) {
    const currentPrice =
      this.priceNode
        ?.textContent
        ?.trim() || '';

    const currencyPrefix =
      currentPrice.match(
        /^[^\d-]+/
      )?.[0] || '€';

    const normalizedPrice =
      price > 999
        ? price / 100
        : price;

    return (
      `${currencyPrefix}` +
      `${normalizedPrice.toFixed(2)}`
    );
  }


  /* =========================================================
     NORMAL SHOPIFY PRICE
  ========================================================= */

syncPriceFromMain(
  sourceDocument = document
) {

  /*
   * CUSTOM POSTER ma własny system ceny.
   */

  if (this.isPoster) {

    return;
  }


  /*
   * Jeśli element sticky posiada:
   *
   * data-live-price-quantity
   *
   * jego właścicielem jest Cloudlift.
   *
   * Dawn NIE może nadpisywać tej ceny.
   */

  if (this.cloudliftManagedPrice) {

    /*
     * Document Printing bez uploadu jest jedynym
     * specjalnym stanem, który nadal kontrolujemy.
     */

    this.applyDocumentPrintingEmptyPrice();

    return;
  }


  /*
   * DOCUMENT PRINTING EMPTY STATE
   */

  if (
    this.applyDocumentPrintingEmptyPrice()
  ) {

    return;
  }


  /*
   * STANDARDOWY FALLBACK DAWN
   */

  const priceRoot =
    sourceDocument?.querySelector?.(
      `#price-${this.sectionId}`
    ) ||
    this.mainPrice;


  if (!priceRoot) {

    return;
  }


  const price =
    priceRoot
      .querySelector('.price-item--sale')
      ?.textContent
      ?.trim()

    ||

    priceRoot
      .querySelector('.price-item--regular')
      ?.textContent
      ?.trim()

    ||

    priceRoot
      .textContent
      ?.replace(/\s+/g, ' ')
      ?.trim();


  if (!price) {

    return;
  }


  const match =
    price.match(
      /€\s*\d+(?:[.,]\d{1,2})?/
    );


  if (!match) {

    return;
  }


  this.setPrice(
    match[0].replace(/\s+/g, '')
  );
}


  setPrice(price) {
    if (!this.priceNode) {
      return;
    }

    if (this.isPoster) {
      return;
    }

    this.priceNode.textContent =
      price;
  }


  /* =========================================================
     BUTTON STATE
  ========================================================= */

  syncButtonState() {
    this.mainSubmit =
      document.getElementById(
        `ProductSubmitButton-${this.sectionId}`
      ) ||
      this.mainSubmit;

    if (
      !this.button ||
      !this.mainSubmit
    ) {
      return;
    }

    const disabled =
      this.mainSubmit.disabled ||
      this.mainSubmit.getAttribute(
        'aria-disabled'
      ) === 'true';

    this.button.toggleAttribute(
      'disabled',
      disabled
    );

    this.button.setAttribute(
      'aria-disabled',
      String(disabled)
    );

    const mainText =
      this.mainSubmit
        .querySelector('span')
        ?.textContent
        ?.trim();

    if (mainText) {
      this.button.textContent =
        mainText;
    }
  }
}


/* =========================================================
   REGISTER
========================================================= */

if (
  !customElements.get(
    'pm-sticky-mobile-cart'
  )
) {
  customElements.define(
    'pm-sticky-mobile-cart',
    PMStickyMobileCart
  );
}